import React, { useState } from 'react';
import { TextBox } from '../TextBox';
import { DropBox } from '../DropBox';
import { Panel, PanelTheme } from '@apply/components';
import { CustomRule } from 'devextreme-react/validator';

export const TextBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');
    const [customValue, setCustomValue] = useState('');
    const [value, setValue] = useState('');
    // Example dropdown items
    const dropdownItems = ['Option 1', 'Option 2', 'Option 3'];

    // Custom validator: value must include the word "test"
    const customValidator = (
        <CustomRule
            message="Value must include 'test'"
            validationCallback={(e: any) => {
                if (!e.value) return true; // Consider empty valid, or adjust as needed.
                return e.value.includes('test');
            }}
        />
    );

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Textbox</li>
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: Basic TextBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={basicValue}
                            onChange={setBasicValue}
                            label='Basic TextBox'
                        />
                    </div>

                    {/* Example 2: Read-Only TextBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={readOnlyValue}
                            onChange={setReadOnlyValue}
                            label='Read-Only TextBox'
                            readOnly={true}
                        />
                    </div>

                    {/* Example 3: Required Field */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={requiredValue}
                            onChange={setRequiredValue}
                            label='Required TextBox'
                            required={true}
                        />
                    </div>

                    {/* Example 4: Custom Validator */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={customValue}
                            onChange={setCustomValue}
                            label='Custom Validator TextBox With Helper Text'
                            helperText="Helper Text: Entry must include the word 'test'."
                            validator={customValidator}
                        />
                    </div>

                    {/* Example 5: Dropdown Box*/}
                    <div style={{ marginBottom: '1rem' }}>
                        <DropBox
                            value={value}
                            onChange={setValue}
                            label='Dropdown Textbox'
                            helperText='Helper Text: Click the arrow to view options'
                            required={true}
                            dropdownItems={dropdownItems}
                        ></DropBox>
                    </div>
                </div>
            </Panel>
        </div>
    );
};
